// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4475ec25","885":"1cbe725c"}[chunkId] + ".chunk.js";
};